<template>
  <div class="appointment-consent-form-receipt">
    <!-- 同意書 -->
    <FlexLayout col :gap="4">
      <div class="detail-row" @click="expand.services = !expand.services">
        <div class="flex items-center">
          <p>{{ displayData.consentFormName }}</p>
          <MaterialIcon v-if="!expand.services">keyboard_arrow_down</MaterialIcon>
          <MaterialIcon v-else>keyboard_arrow_up</MaterialIcon>
        </div>
        <p>
          {{ displayData.consentFormStatus }}
        </p>
      </div>
      <el-collapse-transition>
        <div v-show="expand.services" class="detail-row-container">
          <div v-if="!displayData.enableApplyScope">
            <p class="text-sub text-gray-60">適用所有服務</p>
          </div>
          <div v-else class="detail-col">
            <p v-for="(item, itemIdx) in displayData.consentItems" :key="itemIdx" class="text-sub text-gray-60">{{ item }}</p>
          </div>
        </div>
      </el-collapse-transition>
    </FlexLayout>
  </div>
</template>

<script>
import { defineComponent, computed, reactive, onMounted, ref } from 'vue'
import { ViewSignatureTemplateApplyScopeSetting } from '@/api/signatureTemplate'
import { get, map } from 'lodash'
import { useShop } from '@/use/shop'

export default defineComponent({
  name: 'AppointmentConsentFormReceipt',
  props: {
    items: { type: Array, default: () => [] },
    status: { type: String, default: () => '' },
    name: { type: String, default: () => '' },
    enableApplyScope: { type: Boolean, default: () => false },
  },
  setup (props) {
    const { shopId } = useShop()
    const expand = reactive({
      services: false,
    })
    const applyScopeSettingData = ref([])

    const displayData = computed(() => {
      return {
        consentItems: map(applyScopeSettingData.value, (item) => {
          const lines = []
          if (item.type === 'appointmentCategory') {
            for (const name of item.names) {
              lines.push(`服務類別 ${name}`)
            }
          }
          if (item.type === 'appointmentService') {
            for (const name of item.names) {
              lines.push(`服務項目 ${name}`)
            }
          }
          if (item.type === 'appointmentServiceAttach') {
            for (const name of item.names) {
              lines.push(`服務附加項目 ${name}`)
            }
          }
          if (item.type === 'appointmentSubService') {
            for (const name of item.names) {
              lines.push(`子服務項目 ${name}`)
            }
          }
          return lines
        }).reduce((acc, curr) => acc.concat(curr), []),
        consentFormName: get(props, 'name', ''),
        consentFormStatus: get(props, 'status', ''),
        enableApplyScope: get(props, 'enableApplyScope'),
      }
    })

    const getApplyScopeSettingData = async () => {
      const [res, err] = await ViewSignatureTemplateApplyScopeSetting({
        shopId: shopId.value,
        applyScopeSetting: props.items,
      })

      applyScopeSettingData.value = res
    }

    onMounted(() => {
      if (props.enableApplyScope) {
        getApplyScopeSettingData()
      }
    })

    return {
      expand,
      displayData,
    }
  },
})
</script>

<style lang="postcss" scoped>
.detail-row-container {
  @apply flex flex-col gap-[6px];
  @apply text-gray-60 pl-[8px];
}

.detail-row {
  @apply flex items-center justify-between;
  @apply text-sub cursor-pointer;
}

.detail-col {
  @apply flex flex-col gap-[4px];
}
</style>
